const isDebugMode = new URLSearchParams(window.location.search).get('debug') === 'true';

let panel = null;

function getPanel() {
    if (panel) return panel;
    if (!isDebugMode || !document.body) return null;

    panel = document.createElement('div');
    panel.style.cssText = `
        position: fixed; bottom: 0; left: 0; right: 0;
        max-height: 50vh; overflow-y: auto;
        background: rgba(0,0,0,0.92); color: #00ff00;
        font-family: monospace; font-size: 12px; line-height: 1.5;
        padding: 8px; z-index: 99999;
        border-top: 2px solid #00ff00;
        word-break: break-all;
    `;

    const header = document.createElement('div');
    header.style.cssText = 'color: #ffff00; font-weight: bold; margin-bottom: 6px; font-size: 13px;';
    header.textContent = '[HE Debug] saf-ke-en';
    panel.appendChild(header);

    document.body.appendChild(panel);
    return panel;
}

export function heLog(message, data, isError = false) {
    if (!isDebugMode) return;
    const p = getPanel();
    if (!p) return;

    const line = document.createElement('div');
    line.style.color = isError ? '#ff4444' : '#00ff00';
    line.style.borderBottom = '1px solid #1a1a1a';
    line.style.paddingBottom = '2px';

    const time = new Date().toLocaleTimeString();
    let text = `[${time}] ${message}`;
    if (data !== undefined && data !== null) {
        text += ` — ${typeof data === 'object' ? JSON.stringify(data) : data}`;
    }
    line.textContent = text;

    p.appendChild(line);
    p.scrollTop = p.scrollHeight;
}

export const isHeDebugMode = isDebugMode;
